module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Book.cd7d2bce.woff2";